import React from "react";
import { Breadcrumb } from "antd";
import { HomeOutlined } from "@ant-design/icons";

/**
 * AppBreadcrumb Component
 *
 * A shared breadcrumb component consistent across the entire system.
 * Renders: Home → Parent (clickable if link provided) → Current Page (plain)
 *
 * Usage:
 *   <AppBreadcrumb items={[
 *     { label: "Material Requests", link: "/inventory/material-request/list" },
 *     { label: "Material Request Approvals" },
 *   ]} />
 *
 * @param {Array} items - Array of { label: string, link?: string } objects.
 *   The last item should have no `link` (it's the current page).
 * @param {string} homeLink - Optional custom home link (default "/dash")
 */
const AppBreadcrumb = ({ items = [], homeLink = "/dash" }) => {
  const breadcrumbItems = [
    { href: homeLink, title: <HomeOutlined /> },
    ...items.map((item) => {
      if (item.link) {
        return { href: item.link, title: item.label };
      }
      return { title: item.label };
    }),
  ];

  return <Breadcrumb className="fluid-breadcrumb" items={breadcrumbItems} />;
};

export default AppBreadcrumb;